export enum SOCKET_TRACKING_EVENT {
  create = 'create:tracking',
}
